export const disableEmailPasswordAuthentication =
  import.meta.env.VITE_DISABLE_EMAIL_PASSWORD_AUTHENTICATION === "true";

export const googleWorkplaceDomain: string | undefined = import.meta.env
  .VITE_GOOGLE_WORKPLACE_DOMAIN;

// Upstream only ships SAML SSO (signInWithSSO). The Agentic360 IAM is an OIDC
// provider, not a SAML IdP, so we sign in through a GoTrue external provider
// instead. The value is the provider key configured on GoTrue (e.g. `keycloak`).
export const oidcProvider: string | undefined = import.meta.env
  .VITE_OIDC_PROVIDER;
